import { createSelector } from 'reselect'
import * as utility from '../../../apis/utility'
import translations from '../../../utilties/languages/locales'
import * as cookies from '../../../utilties/cookies'
import locale2 from 'locale2'
import VerifyPhoneNumber from '../../../components/VerifyPhoneNumber'
import RedirectErrorDialog from '../../../pages/templates/components/RedirectErrorDialog'

const SHOW_MODAL = 'SHOW_MODAL'

export const showModal = (component, options, canClose = true) => (dispatch) => {
	return dispatch({ type: SHOW_MODAL, data: { component: component, options, show: true, canClose: canClose } })
}

const SHOW_AUTH_ERROR_DIALOG = 'SHOW_AUTH_ERROR_DIALOG'
export const showAuthErrorDialog = (options) => (dispatch) => {
	return dispatch({ type: SHOW_AUTH_ERROR_DIALOG, data: { options } })
}

const SET_SNACKBAR_MESSAGE = 'SET_SNACKBAR_MESSAGE'
export const setSnackbarMessage = (message) => (dispatch) => {
	return dispatch({ type: SET_SNACKBAR_MESSAGE, data: message })
}

export const hideModal = () => (dispatch) => {
	return dispatch({ type: SHOW_MODAL, data: { component: null, show: false, options: null } })
}

const CLEAR_SNACKBAR_MESSAGE = 'CLEAR_SNACKBAR_MESSAGE'
export const clearSnackbarMessage = () => (dispatch) => {
	return dispatch({ type: SET_SNACKBAR_MESSAGE, data: {message: null, isSuccess:null} })
}

const SHOW_TOP_HEADER = 'SHOW_TOP_HEADER'
export const showTopHeader = (setTopHeader) => (dispatch) => {
	return dispatch({type: SHOW_TOP_HEADER, data: {showTopHeader: setTopHeader}})
}

const START_SAVING_REQUESTED = 'START_SAVING_REQUESTED'
export const startSaving = () => (dispatch) => {
	return dispatch({ type: START_SAVING_REQUESTED, data: {} })
}

const STOP_SAVING_REQUESTED = 'STOP_SAVING_REQUESTED'
export const stopSaving = () => (dispatch, getState) => {
	return dispatch({ type: STOP_SAVING_REQUESTED, data: {} })
}

const SET_UPLOADING_COUNT = 'SET_UPLOADING_COUNT'
export const setUploadingCount = (val) => (dispatch, getState) => {
	return dispatch({ type: SET_UPLOADING_COUNT, data: val })
}

export const pageLoadHandler = (p) => (dispatch) => {
    dispatch(refreshIntlLocale());
}

const REFRESH_INTL_LOCALE_REQUESTED = 'REFRESH_INTL_LOCALE_REQUESTED'
export const refreshIntlLocale = () => (dispatch) => {

    let locale = 'en';
    let localeCookie = cookies.get('languageAbbreviation');

    if (localeCookie) {
        locale = localeCookie;
    }
    else if (locale2) {
        locale = locale2.substring(0, 5)
		if (locale !== 'en-GB'){
			locale = locale2.substring(0, 2)
		}
    }

    if (!translations[locale]) {
        locale = 'en'
    }
	
    return dispatch({ type: REFRESH_INTL_LOCALE_REQUESTED, data: { locale: locale, messages: translations[locale] } });
}

const FETCH_CURRENT_BACKEND_VERSION_REQUESTED = 'FETCH_CURRENT_BACKEND_VERSION_REQUESTED'
const FETCH_CURRENT_BACKEND_VERSION_SUCCESS = 'FETCH_CURRENT_BACKEND_VERSION_SUCCESS'
const FETCH_CURRENT_BACKEND_VERSION_FAILED = 'FETCH_CURRENT_BACKEND_VERSION_FAILED'

export const fetchCurrentBackendVersion = () => (dispatch) => {
	dispatch({ type: FETCH_CURRENT_BACKEND_VERSION_REQUESTED, data: {} })

	return utility.fetchCurrentBackendVersion().then((response) => {
        if (response && response.isSuccessful) {
			return dispatch({ type: FETCH_CURRENT_BACKEND_VERSION_SUCCESS, data: response.data })
		} else if(!response || !response.redirectTo) {
			return dispatch({ type: FETCH_CURRENT_BACKEND_VERSION_FAILED, data: response.data })
        }
    })
}

const FETCH_COUNTRY_REQUESTED = 'FETCH_COUNTRY_REQUESTED'
const FETCH_COUNTRY_SUCCESS = 'FETCH_COUNTRY_SUCCESS'
const FETCH_COUNTRY_FAILED = 'FETCH_COUNTRY_FAILED'

export const fetchClientCountry = () => (dispatch, getState) => {
	let state = getState();
	if (!state.core.country) {
		dispatch({ type: FETCH_COUNTRY_REQUESTED, data: {} })

		return utility.fetchClientCountry().then((response) => {
			if (response) {
				return dispatch({ type: FETCH_COUNTRY_SUCCESS, data: response.country })
			} else if(!response || !response.redirectTo) {
				return dispatch({ type: FETCH_COUNTRY_FAILED, data: {} })
			}
		})
	}
}

const SET_VERSION_MISMATCH_ALERT_VISIBILITY_SUCCESS = 'SET_VERSION_MISMATCH_ALERT_VISIBILITY_SUCCESS'

export const setVersionMismatchAlertVisibility = (state) => (dispatch) => {
	dispatch({ type: SET_VERSION_MISMATCH_ALERT_VISIBILITY_SUCCESS, data: state })
}

const SET_ERROR_CODE = 'SET_ERROR_CODE'
export const setErrorCode = (errorCode) => (dispatch) => {
	return dispatch({type: SET_ERROR_CODE, data: errorCode})
}

const RESET_ERROR_CODE = 'RESET_ERROR_CODE'
export const resetErrorCode = () => (dispatch) => {
	return dispatch({type: RESET_ERROR_CODE, data: null})
}

const initial = {
	show: false,
	showTopHeader: false,
	component: null,
	params:null,
	message: null,
	isSnackMessageSuccess: false,
	isSaving: false,
	currentBackendVersion: null,
    isVersionMismatchAlertVisible: false,
	locales: {
		locale: 'en',
		messages: []
    },
	country: null,
	errorCode: null
}

export const reducer = (state = initial, action) => {
	switch (action.type) {
		case START_SAVING_REQUESTED:
			return { ...state, isSaving: true }
		case STOP_SAVING_REQUESTED:
			return { ...state, isSaving: false }
		case SET_UPLOADING_COUNT:
			return {...state, uploadingCount: action.data }
		case SHOW_MODAL:
			return {
				...state,
				show: action.data.show,
				component: action.data.component,
				params: action.data.options,
				canClose: action.data.canClose,
				onClose: action.data.onClose
			}
		case SHOW_AUTH_ERROR_DIALOG:
			return {
				...state,
				show: true,
				component: RedirectErrorDialog,
				params: action.data.options,
				canClose: false,
				onClose: null
			}
		case SET_SNACKBAR_MESSAGE:
			return { ...state, message: action.data.message, isSnackMessageSuccess: action.data.isSuccess }
		case CLEAR_SNACKBAR_MESSAGE:
			return { ...state, message: null, isSnackMessageSuccess: false }
		case SHOW_TOP_HEADER: 
			return { ...state, showTopHeader: action.data.showTopHeader }
		case REFRESH_INTL_LOCALE_REQUESTED:
			return { ...state, locales: action.data }
		case FETCH_CURRENT_BACKEND_VERSION_SUCCESS:
            return {
				...state, currentBackendVersion: action.data
			}
		case SET_VERSION_MISMATCH_ALERT_VISIBILITY_SUCCESS:
			return { ...state, isVersionMismatchAlertVisible: action.data }
		case FETCH_COUNTRY_SUCCESS:
			return { ...state, country: action.data }
		case SET_ERROR_CODE:
			return { ...state, errorCode: action.data }
		case RESET_ERROR_CODE:
			return { ...state, errorCode: null }
		default:
			return { ...state }
	}
}

const mainSelector = (state) => state.core

export const confirmedSelector = (state) => {
	return state.auth.confirmed
}

export const errorSelector = (state) => {
	return state.auth.error
}

export const isSavingSelector = createSelector(mainSelector, (state) => {
	return state.isSaving
})

export const uploadingCountSelector = createSelector(mainSelector, (state) => {
	return state.uploadingCount
})

export const intlLocaleSelector = createSelector(mainSelector, (state) => {
	return state.locales
})

export const currentBackendVersionSelector = createSelector(mainSelector, (state) => {
	return state.currentBackendVersion
})

export const isVersionMismatchAlertVisibleSelector = createSelector(mainSelector, (state) => {
	return state.isVersionMismatchAlertVisible
})

export const clientCountrySelector = createSelector(mainSelector, (state) => {
	return state.country
})

export const errorCodeSelector = createSelector(mainSelector, (state) => {
	return state.errorCode
})